import { useDispatch } from 'react-redux';

import {
    updatePageComponents,
    dispatchGraphQLResponse,
    dispatchAsyncComponents,
    updateSEO,
} from '../page/page-actions';

/**
 * @typedef {Object} PageFunctions
 * @property {function(): promise} updateComponent - Update a page component in redux
 */

/**
 * Returns redux connected page functions
 * @name usePage
 * @returns {PageFunctions}
 */
export default function usePage() {
    const dispatch = useDispatch();

    return {
        updateComponent: (component, mergeFunction) => dispatch(updatePageComponents(component, mergeFunction)),
        updateSeo: (seo, mergeFunction) => dispatch(updateSEO(seo, mergeFunction)),
        dispatchGraphQLResponse: response => dispatch(dispatchGraphQLResponse(response, dispatch)),
        dispatchAsyncComponents: response => dispatch(dispatchAsyncComponents(response, dispatch)),
    };
}
